<script>
/* eslint-disable no-unused-vars */
const General = () => import('./components/index.vue')
import dataView from 'src/modules/pages/view'
import contentPage from './components/index'

export default {
  mixins: [dataView],
  name: "ribbons",
  data() {
    return {
      route: 'Ribbons',
    }
  },
  components: {
    'contentPage' : contentPage
  }
}
</script>
